// extracted by mini-css-extract-plugin
module.exports = {"root":"sidebar_root__2hY6V","wsForm":"sidebar_wsForm__2YH-V","inputGroup":"sidebar_inputGroup__2uTg-","scripts":"sidebar_scripts__3NUhx"};